import Vue from 'vue';
import ContractList from './components/ContractList';
import store from './../../lib/store';
import { sanitize } from '../../lib/utils';
import Marker from '../../lib/markers/marker';
import Columnator from '../../lib/columnator';
import IndexView from '../../lib/index-view.js';
import Deletism from '../../lib/markers/deletism';
import Undeletism from '../../lib/markers/undeletism';
import Downloader from '../../lib/markers/downloader';

export default function() {
  const allContractList = new Vue({
    el: '#contract-list',
    components: {
      'contract-list': ContractList
    },
    store
  });

  $(document).one('pjax:end', () => {
    allContractList.$destroy();
  });

  const marker = new Marker('contracts');
  new IndexView();
  new Columnator();
  new Deletism(marker);
  new Undeletism(marker);
  new Downloader(marker);

  // Autocomplete
  let entryField = $('#entry');

  entryField.select2({
    ajax: {
      url: '/contract/entry/autocomplete',
      dataType: 'json',
      delay: 250,
      data: function(searchTerm) {
        return {
          keyword: searchTerm
        };
      },
      results: function(data) {
        return {
          results: data
        };
      },
      cache: true
    },
    formatResult: function(entry) {
      return sanitize(entry.title);
    },
    formatSelection: function(entry) {
      return sanitize(entry.title);
    },
    initSelection: function(element, callback) {
      let slug = $(element).val();
      if (slug !== '') {
        $.ajax('/contract/entry/single/' + slug, {
          dataType: 'json'
        }).done(function(data) {
          callback(data);
        });
      }
    },
    minimumInputLength: 3
  });
}
